import { toJS } from 'mobx'
import { store } from '../store'

export const debugRootStore = () => Object.fromEntries(Object.entries(store).map(i => [i[0], toJS(i[1])]))

export const debounce = (fn: Function, ms: number = 0) => {
  let timeoutId: any
  return (...args: any[]) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), ms)
  }
}

export const intersect = <T>(arr1: T[], arr2: T[]): T[] => {
  return arr1.filter(i => arr2.includes(i))
}

export const validateEmail = (email: string): boolean => {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const toString = (value: any, separator: string = ', '): string => {
  if (Array.isArray(value)) {
    return value.join(separator)
  }
  return String(value ?? '')
}

export const uploadFile = (type: 'excel' | '' = ''): Promise<File> => {
  const mimeTypes = {
    excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }

  return new Promise(resolve => {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('style', 'display: none')
    input.setAttribute('accept', type ? mimeTypes[type] || '' : '')
    input.click()
    input.addEventListener('change', onFileSelect)

    function onFileSelect (e: any) {
      const file = e?.target?.files?.[0]
      file && resolve(file)
      input.removeEventListener('change', onFileSelect)
      input.remove()
    }
  })
}

export const loadScript = (src: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.onload = resolve
    script.onerror = reject
    script.src = src
    document.head.append(script)
  })
}

export const delay = (ms: number): Promise<void> => {
  return new Promise<void>(r => setTimeout(r, ms))
}

export const omitFields = (obj: TObjectAny, fields: string[]): TObjectAny => {
  const result = { ...obj }
  fields.forEach(f => delete result[f])
  return result
}
